const articleImages: Record<string, string> = {
  'news-football-worldcup': 'https://readdy.ai/api/search-image?query=Professional%20soccer%20stadium%20atmosphere%20with%20dramatic%20lighting%2C%20players%20in%20action%20on%20green%20field%2C%20golden%20hour%20sunlight%2C%20editorial%20sports%20photography%20style%2C%20clean%20composition%2C%20crowd%20silhouettes%20in%20background&width=800&height=450&seq=news-football-worldcup&orientation=landscape',
  'news-nba-trade': 'https://readdy.ai/api/search-image?query=Professional%20basketball%20court%20with%20dramatic%20spotlight%20effect%2C%20athletic%20silhouette%20dunking%2C%20warm%20golden%20and%20deep%20red%20tones%2C%20editorial%20sports%20photography%2C%20clean%20background%20with%20arena%20lights&width=800&height=450&seq=news-nba-trade&orientation=landscape',
  'news-lol-s16': 'https://readdy.ai/api/search-image?query=Esports%20gaming%20arena%20with%20dramatic%20stage%20lighting%2C%20neon%20accents%2C%20modern%20competitive%20gaming%20setup%2C%20atmospheric%20crowd%20shots%2C%20professional%20esports%20photography%20style%2C%20dark%20background%20with%20colorful%20highlights&width=800&height=450&seq=news-lol-s16&orientation=landscape',
  'news-epl-preview': 'https://readdy.ai/api/search-image?query=English%20premier%20league%20soccer%20stadium%20panoramic%20view%2C%20vibrant%20green%20pitch%2C%20packed%20stadium%20crowd%2C%20golden%20afternoon%20light%2C%20editorial%20sports%20journalism%20photography%2C%20clean%20and%20professional%20composition&width=800&height=450&seq=news-epl-preview&orientation=landscape',
  'news-award-2026': 'https://readdy.ai/api/search-image?query=Elegant%20award%20ceremony%20stage%20with%20golden%20trophy%2C%20warm%20spotlight%2C%20professional%20event%20photography%2C%20dark%20sophisticated%20background%2C%20celebration%20atmosphere%2C%20clean%20modern%20composition%20with%20soft%20bokeh&width=800&height=450&seq=news-award-2026&orientation=landscape',
  'news-tennis-guide': 'https://readdy.ai/api/search-image?query=Professional%20tennis%20court%20with%20golden%20hour%20lighting%2C%20tennis%20ball%20in%20motion%2C%20athletic%20aesthetics%2C%20editorial%20sports%20photography%2C%20clean%20composition%2C%20warm%20natural%20light%20with%20soft%20shadows&width=800&height=450&seq=news-tennis-guide&orientation=landscape',
};

import { newsArticles } from '@/mocks/homeData';

export default function NewsSection() {
  return (
    <section className="relative w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-8 md:mb-10 gap-4">
          <div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 tracking-tight mb-2">
              赛事资讯
            </h2>
            <p className="text-sm text-foreground-500">最新体育赛事动态与平台资讯</p>
          </div>
          <a
            href="/category/news"
            className="flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            查看全部资讯 <i className="ri-arrow-right-line text-xs"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {newsArticles.slice(0, 6).map((article) => (
            <article key={article.id} className="group">
              <a
                href={`/article/${article.id}`}
                className="block bg-background-50 rounded-xl border border-background-200 overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
              >
                <div className="relative h-48 md:h-52 overflow-hidden">
                  <img
                    src={articleImages[article.imageSeq]}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-background-50/90 backdrop-blur-sm text-foreground-800">
                      {article.category}
                    </span>
                  </div>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="text-base font-bold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-foreground-400">
                      <i className="ri-calendar-line mr-1"></i>{article.date}
                    </span>
                    <span className="text-xs font-medium text-primary-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      阅读全文 <i className="ri-arrow-right-s-line"></i>
                    </span>
                  </div>
                </div>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}